import axios from "axios";
import { LoginDto } from "../interfaces/dto/LoginDto";

export const login = (loginDto: LoginDto) => {
    return axios.post("/authentication/login", loginDto);
};
